import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const logConfig = {
  getLogErrors: {
    key: "getLogErrors",
    url: "/api/v1/log/errors",
    method: "GET",
    options: {
      staleTime: STALE_TIME.SHORT,
      gcTime: GC_TIME.NORMAL,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
  getLogDates: {
    key: "getLogDates",
    url: "/api/v1/log/dates",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
      refetchOnWindowFocus: false,
    },
  },
  deleteLogError: {
    key: "deleteLogError",
    url: (data) => `/api/v1/log/errors/${data.id}`,
    method: "DELETE",
    options: {
      retry: 1,
      invalidateKeys: ["getLogErrors"],
    },
  },
};
